// hooks/useDisconnectHandler.js
import { useDisconnect } from "wagmi";

const useDisconnectHandler = () => {
  const { disconnect } = useDisconnect();

  const disconnectWallet = () => {
    disconnect();
  };

  return { disconnectWallet };
};

export default useDisconnectHandler;
